import { UserOrg } from 'graphql/types/userOrgs';

export type OrgListContextType = {
    orgList: UserOrg[];
    setOrgList: (orgList: UserOrg[]) => void;
};

export const OrgListContextDefaultValues: OrgListContextType = {
    orgList: [],
    // biome-ignore lint/suspicious/noEmptyBlockStatements: inherited from operator
    setOrgList: () => {},
};
